import { render, staticRenderFns } from "./showPrizeMod.vue?vue&type=template&id=4fb6e4a8&scoped=true&"
import script from "./showPrizeMod.vue?vue&type=script&lang=ts&"
export * from "./showPrizeMod.vue?vue&type=script&lang=ts&"
import style0 from "./showPrizeMod.vue?vue&type=style&index=0&id=4fb6e4a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6e4a8",
  null
  
)

export default component.exports